import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { useEffect } from "react";
import utils from "services/utils";
import { StyledIcon } from "styled-components/Common/CommonStyled";
import { StyledGoogleTranslate } from "styled-components/WidgetBuilder/WidgetBuilderStyled";

const GoogleTranslate = (props) => {
	const { margin, isNewLayout = false } = props;

	const TARGET_ELEMENT_ID = "google_translate_element";

	useEffect(() => {
		utils.googleTranslateScript();
	}, []);

	return (
		<StyledGoogleTranslate
			id={TARGET_ELEMENT_ID}
			isMobile={utils.isMobileWidth() && !isNewLayout}
			margin={margin}
			style={{ minHeight: "60px" }}>
			<StyledIcon size={14} colorStroke="rgba(0, 0, 0, 0.25)">
				<ChevronDownIcon />
			</StyledIcon>
		</StyledGoogleTranslate>
	);
};

export default GoogleTranslate;
